import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // ✅ správný import
import './BusinessLogin.css';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';

const BusinessLogin = () => {
  const [businessLoginData, setBusinessLoginData] = useState({
    email: '',
    password: '',
  });
  const [message, setMessage] = useState('');
  const { businessLogin } = useAuth(); // ✅ nepotřebujeme `businessToken` ani `businessAdminToken` z contextu
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBusinessLoginData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/business/login`,
        businessLoginData
      );

      if (response.data && response.data.businessToken) {
        const token = response.data.businessToken;

        // Uložit token
        businessLogin(token);
        setMessage(response.data.message);

        // Dekódovat token
        const decoded = jwtDecode(token);
        const userType = decoded.type;

        // Přesměrování podle role
        setTimeout(() => {
          setMessage(null);
          if (userType === 'admin') {
            navigate('/business/admin-profile');
          } else {
            navigate('/business/profile');
          }
        }, 1000);
      } else {
        console.log('Chyba přihlášení: Token chybí v odpovědi');
        setMessage('Přihlášení selhalo. Zkuste to znovu.');
      }
    } catch (err) {
      console.log('Chyba při odesílání požadavku:', err);
      setMessage(err.response?.data.message || err.message);
    } finally {
      // Automatické smazání hlášky po 3 vteřinách
      setTimeout(() => setMessage(null), 3000);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-height">
      <Navbar />
      <div className="login-container">
        <h2 className="login-title">Přihlášení podniku</h2>
        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Email"
            name="email"
            value={businessLoginData.email}
            onChange={handleInputChange}
            required
            className="login-input"
          />
          <input
            type="password"
            placeholder="Heslo"
            name="password"
            value={businessLoginData.password}
            onChange={handleInputChange}
            required
            className="login-input"
          />
          <button type="submit" className="login-button">Přihlásit se</button>
        </form>

        <div className="login-links">
          <Link to="/business/forgot-password" className="login-link">Zapomenuté heslo?</Link>
          <Link to="/business/register" className="login-link">Registrovat</Link>
        </div>

        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
};

export default BusinessLogin;